module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), (!_vm.isSubmitted) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "publicE106"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "publicE106Project"
    }
  }, [_c('h4', [_vm._v("Project")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.projectName')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projectName",
      "type": "text",
      "placeholder": "Project Name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.projectName')),
      expression: "errors.has('publicE106.projectName')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Project Name is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.projectTypeId')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Project Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.projectTypeId),
      expression: "project.projectTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projectTypeId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "projectTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.projectTypeList), function(projectType) {
    return _c('option', {
      key: projectType.projectTypeId,
      domProps: {
        "value": projectType.projectTypeId
      }
    }, [_vm._v("\n                                            " + _vm._s(projectType.description) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.projectTypeId')),
      expression: "errors.has('publicE106.projectTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Project Type is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.leadAgency')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Lead Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.agencyId),
      expression: "project.agencyId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "leadAgency",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "agencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.leadOrganizationList), function(organization) {
    return _c('option', {
      key: organization.id,
      domProps: {
        "value": organization.id
      }
    }, [_vm._v(_vm._s(organization.description))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.leadAgency')),
      expression: "errors.has('publicE106.leadAgency')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Lead Agency is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLeadOrganization && _vm.selectedLeadOrganization.hasUsers === false && !_vm.selectedLeadOrganization.agencyNoReview),
      expression: "selectedLeadOrganization && selectedLeadOrganization.hasUsers === false && !selectedLeadOrganization.agencyNoReview"
    }],
    staticClass: "has-error"
  }, [_vm._v("\n                                        Selected Lead Agency has no Wyotrack users\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.agencyNumber),
      expression: "project.agencyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Agency Number"
    },
    domProps: {
      "value": (_vm.project.agencyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "agencyNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.client')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.clientId),
      expression: "project.clientId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "clientId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                            " + _vm._s(organization.description) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.client')),
      expression: "errors.has('publicE106.client')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Client is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.fieldOrganizationId),
      expression: "project.fieldOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrganizationId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "fieldOrganizationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.organizationId
      }
    }, [_vm._v("\n                                            " + _vm._s(organization.description) + "\n                                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Field Org. Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.fieldOrgNumber),
      expression: "project.fieldOrgNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fieldOrgNumber",
      "type": "text",
      "placeholder": "Field Org. Number"
    },
    domProps: {
      "value": (_vm.project.fieldOrgNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "fieldOrgNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.isFederalAgencyImpacted),
      expression: "project.isFederalAgencyImpacted"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsFederalAgencyImpacted",
      "disabled": !_vm.isFederalAgencyImpactedCheckboxEnabled
    },
    domProps: {
      "checked": Array.isArray(_vm.project.isFederalAgencyImpacted) ? _vm._i(_vm.project.isFederalAgencyImpacted, null) > -1 : (_vm.project.isFederalAgencyImpacted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.project.isFederalAgencyImpacted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.project.isFederalAgencyImpacted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.project.isFederalAgencyImpacted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.project, "isFederalAgencyImpacted", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "IsFederalAgencyImpacted"
    }
  }, [_vm._v("Is this a federal undertaking?")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "publicE106Main"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.projectDescription')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Project Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.projectDescription),
      expression: "complianceDto.projectDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projectDescription",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.complianceDto.projectDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "projectDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.projectDescription')),
      expression: "errors.has('publicE106.projectDescription')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Project Description is required")])])]), _vm._v(" "), _c('h4', [_vm._v("Property Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "addPropertyInfo"
    },
    on: {
      "click": function($event) {
        _vm.addNewPropertyInfo()
      }
    }
  }, [_vm._v("Add Property Information")])])]), _vm._v(" "), _c('div', [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.propertyInfoGridSpec.tableData,
      "columns": _vm.propertyInfoGridSpec.columns,
      "options": _vm.propertyInfoGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.editPropertyInformation(props.row)
            }
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePropertyInformation(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('h4', [_vm._v("PLSS Locations")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button3"
    },
    on: {
      "click": function($event) {
        _vm.showSectionModal()
      }
    }
  }, [_vm._v("Add PLSS Locations")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Add Sections(s)",
      "effect": "fade/zoom",
      "value": _vm.sectionModalShow
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add PLSS Locations")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    attrs: {
      "showTitle": false
    },
    on: {
      "savePlss": _vm.savePlssE106Compliance
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSectionModal
    }
  }, [_vm._v("Exit")])])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.plssLocationGridSpec.tableData.length > 0),
      expression: "plssLocationGridSpec.tableData.length > 0"
    }]
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('h4', [_vm._v("Land Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.landUseDescription')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Description of Current Land Use")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.currentLandUse),
      expression: "complianceDto.currentLandUse"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "landUseDescription",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.complianceDto.currentLandUse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "currentLandUse", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.landUseDescription')),
      expression: "errors.has('publicE106.landUseDescription')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Description of Current Land Use is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.previousDisturbances')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Nature of Any Previous Disturbances")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.previousDisturbances),
      expression: "complianceDto.previousDisturbances"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "previousDisturbances",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.complianceDto.previousDisturbances)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "previousDisturbances", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.previousDisturbances')),
      expression: "errors.has('publicE106.previousDisturbances')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Nature of Any Previous Disturbances is required")])])]), _vm._v(" "), _c('modal2', {
    ref: "propertyInfoModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Property Information")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['propertyInfoModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.streetAddress),
      expression: "selectedPropertyInfo.streetAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.streetAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "streetAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.city),
      expression: "selectedPropertyInfo.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("County")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.county),
      expression: "selectedPropertyInfo.county"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.county)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "county", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Zip Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.zipCode),
      expression: "selectedPropertyInfo.zipCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "zipCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Lot")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.lot),
      expression: "selectedPropertyInfo.lot"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.lot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "lot", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.block),
      expression: "selectedPropertyInfo.block"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.block)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "block", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Date of Construction")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.constructionDate),
      expression: "selectedPropertyInfo.constructionDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.constructionDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "constructionDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Dates of Additions/Modifications")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.additionsModificationsDates),
      expression: "selectedPropertyInfo.additionsModificationsDates"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.additionsModificationsDates)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "additionsModificationsDates", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Proposed Changes and Brief History of the Building")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.proposedChangesBriefHistory),
      expression: "selectedPropertyInfo.proposedChangesBriefHistory"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.proposedChangesBriefHistory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "proposedChangesBriefHistory", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.savePropertyInformation()
      }
    }
  }, [_vm._v("Save")])])])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "form-group",
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "publicE106Document"
    }
  }, [_c('h4', [_vm._v("Documents")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('documents', {
    ref: "documents",
    attrs: {
      "parentId": null,
      "formDisabled": false,
      "loadOnMount": false,
      "addOnly": true
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "form-group",
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "publicE106Contact"
    }
  }, [_c('h4', [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.submitterFirstName')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterFirstName),
      expression: "complianceDto.submitterFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterFirstName",
      "type": "text",
      "placeholder": "Submitter First Name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterFirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.submitterFirstName')),
      expression: "errors.has('publicE106.submitterFirstName')"
    }],
    staticClass: "has-error"
  }, [_vm._v("First Name is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.submitterLastName')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterLastName),
      expression: "complianceDto.submitterLastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterLastName",
      "type": "text",
      "placeholder": "Submitter Last Name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.submitterLastName')),
      expression: "errors.has('publicE106.submitterLastName')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Last Name is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.submitterEmail')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterEmail),
      expression: "complianceDto.submitterEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterEmail",
      "type": "text",
      "placeholder": "user@example.com",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.submitterEmail')),
      expression: "errors.has('publicE106.submitterEmail')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Email is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('publicE106.submitterPhone')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterPhone),
      expression: "complianceDto.submitterPhone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterPhone",
      "type": "tel",
      "placeholder": "123-45-6789",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('publicE106.submitterPhone')),
      expression: "errors.has('publicE106.submitterPhone')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Phone Number is required")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "form-group",
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any()),
      expression: "errors.any()"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validationList.length > 0),
      expression: "validationList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.validationList), function(validationMsg) {
    return _c('li', {
      key: validationMsg
    }, [_vm._v(_vm._s(validationMsg))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitServerError),
      expression: "submitServerError"
    }]
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "pe106-submission"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "button2",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": function($event) {
        _vm.submitPrep()
      }
    }
  }, [_vm._v("Submit")])])])])]) : _c('div', [(_vm.submitMediaError) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Your E-106 Submission is received. However, there was an error submitting your uploaded documents.")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/home",
      "tag": "a"
    }
  }, [_vm._v("Return")])], 1)]) : _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Your E-106 Submission is received, thank you.")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/home",
      "tag": "a"
    }
  }, [_vm._v("Return")])], 1)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("E-106 Submission")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "1.5em"
    }
  }, [_vm._v("\n            To request a Section 106 compliance letter for a proposed project from the Wyoming SHPO you will need to fill out the form below.\n             Based on a file search and our review of the project area, we will provide written comments on the potential for the project to affect\n             historic properties and recommendations for further cultural resource investigations. Things you will need to have ready to fill out this form include:\n            "), _c('br'), _c('br'), _vm._v("\n                •  Name and adequate description of project\n            "), _c('br'), _vm._v("\n                •  Name of project proponent\n            "), _c('br'), _vm._v("\n                •  Project location (township, range, section)\n            "), _c('br'), _vm._v("\n                •  Name of lead federal (or state) agency permitting, authorizing, or funding project\n            "), _c('br'), _vm._v("\n                •  Current land use and nature of any previous disturbances in project area\n            "), _c('br'), _vm._v("\n                •  A copy of a USGS 7.5 minute topographic map with the project area outlined or highlighted\n            "), _c('br'), _vm._v("\n                •  Photos of the project area\n            "), _c('br'), _vm._v("\n                •  Date(s) of building/structure construction, if applicable\n            "), _c('br'), _c('br'), _vm._v("\n            The form below is only for select types of projects and is not a substitute for the normal review and consultation process.\n            "), _c('br'), _c('br'), _vm._v("\n            If a cultural resource inventory report has already been prepared for a specific project, it should first be reviewed by the lead permitting\n             agency for the project through WyoTrack. That agency will then send a copy of the report to the SHPO through WyoTrack with their comments and determinations\n             and a request for SHPO review. If the permitting agency has authorized a project proponent or cultural resource consultant to send a copy of the report\n             directly to the SHPO, send a cover letter along with the report that explains the situation, requests SHPO review and comment, and provides information\n             about who should receive the SHPO response letter. All of these things are done through WyoTrack. Please visit\n             "), _c('a', {
    attrs: {
      "href": "https://wyoshpo.wyo.gov/index.php/programs/cultural-records/wyotrack",
      "target": "”_blank”"
    }
  }, [_vm._v("https://wyoshpo.wyo.gov/index.php/programs/cultural-records/wyotrack")]), _vm._v(" if you have\n             questions or need access to WyoTrack.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Errors encountered while submitting your form. Please try again later.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Submission")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7bc59e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PublicE106.vue
// module id = 956
// module chunks = 1